import {loadJsFile} from 'lib/helpers/common';

export const initRemoteJS = (id) => {
    const url = "https://remotejs.com/agent/agent.js";
    const props = [['data-consolejs-channel', id]];

    loadJsFile(url, props)
}
